import React, { useState } from "react";
import axios from "../../../library/axios";
import { MySwal } from "../../../library/swal";
import Button from "react-bootstrap/Button";
import { useParams } from "react-router";
import { IconDeviceFloppy, IconSquareX } from "@tabler/icons-react";
import { getSlug, } from "../../../../src/config/routes/guards/slug";

const CreatePpsDokumenComp = (props) => {
  const url = new URL(window.location.href);

  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const [namaDokumen, setnamaDokumen] = useState("");
  // const [dokumen, setDokumen] = useState('');
  const [base64String, setBase64String] = useState("");
  // const [mimeType, setMimeType] = useState('');
  const [originalName, setOriginalName] = useState("");
  // const [syncSpeakOnline, setsyncSpeakOnline] = useState("Tidak");

  const routeParams = useParams();

  const handleImageChange = (e) => {
    const selectedFile = e.target.files[0];
    // console.log(selectedFile.type);
    // return false;
    if (
      selectedFile.type !== "application/pdf" &&
      selectedFile.type !== "application/vnd.ms-excel" &&
      selectedFile.type !==
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      MySwal.fire({
        icon: "error",
        title: "Oops, Error!",
        text: `File Dokumen hanya boleh PDF atau Excel`,
      });
      setDisabled(true);
      return false;
    }
    setDisabled(false);

    const file = e.target.files[0];
    setOriginalName(file.name);

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = reader.result;
        setBase64String(base64);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleCreate = () => {
    setLoading(true);
    setDisabled(true);

    const requestBody = {
      baseUrl: url.origin,
      idItemPps: routeParams.id,
      syncSpeakOnline: "Tidak",
      nama_dokumen: namaDokumen || originalName,
      dokumen: base64String,
    };
    // console.log(requestBody);
    // return false;
    axios({
      url: "/pps-item/upload-dokumen-pps",
      method: "POST",
      data: requestBody,
      headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
    })
      .then((res) => {
        // console.log(res)
        // return false
        if (res.status === 200) {
          MySwal.fire({
            icon: "success",
            title: "Success",
            text: "Successfully tambah dokumen!",
          });

          setLoading(false);
          setDisabled(false);

          props.close();
          props.fetch();
        }
      })
      .catch((err) => {
        setLoading(false);
        setDisabled(false);
        if (err !== "") {
          console.log(err?.response?.data?.message);
          MySwal.fire({
            icon: "error",
            title: "Oops, Error!",
            text: `${err?.response?.data?.message}`,
          });
        }
      });
  };

  return (
    <>
      <div className="mb-3 row">
        <label htmlFor="dokumen" className="col-sm-12 col-form-label required">
          Upload Dokumen
        </label>
        <div className="col-12 mb-1">
          <input
            type="file"
            onChange={handleImageChange}
            className="form-control"
            id="dokumen"
          />
        </div>
        <span>
          <i className="text-info required">
            Dokumen harus dalam bentuk PDF atau Excel
          </i>
        </span>
      </div>
      <div className="mb-3 row">
        <label htmlFor="namaFile" className="col-sm-12 col-form-label">
          Nama Dokumen
        </label>
        <div className="col-12">
          <input
            type="text"
            onChange={(e) => setnamaDokumen(e.target.value)}
            className="form-control"
            id="namaFile"
            autoComplete="off"
          />
        </div>
      </div>
      {/* <div className="mb-3 row">
        <label htmlFor="syncSpeakOnline" className="col-sm-12 col-form-label">
          Sync SPEAK Online
        </label>
        <div className="col-12">
          <select
            className="form-control"
            id="syncSpeakOnline"
            name="syncSpeakOnline"
            onChange={(e) => setsyncSpeakOnline(e.target.value)}
            value={syncSpeakOnline}
          >
            <option value="Tidak">Tidak</option>
            <option value="Ya">Ya</option>
          </select>
          {syncSpeakOnline === "Tidak" ? (
            <small className="text-info">
              Dokumen tidak akan di sinkron ke SPEAK Online.
            </small>
          ) : (
            <small className="text-info">
              Dokumen akan langsung di sinkron ke SPEAK Online.
            </small>
          )}
        </div>
      </div> */}

      <div className="mt-5 row">
        <div className="d-flex flex-center flex-row-fluid pt-2">
          <Button
            disabled={disabled}
            variant="primary"
            size="sm"
            onClick={() => handleCreate()}
          >
            <IconDeviceFloppy stroke={2} />{" "}
            {loading === true ? "Mohon Tunggu.." : "Simpan"}
          </Button>
          &nbsp;
          <Button variant="danger" size="sm" onClick={() => props.close()}>
            <IconSquareX stroke={2} /> Tutup
          </Button>
        </div>
      </div>
    </>
  );
};

export default CreatePpsDokumenComp;
